<main role="main">
  <app-hero></app-hero>
  @defer (on idle) {
    <app-benefits></app-benefits>
<!--    <app-faqs></app-faqs>-->
  }
</main>
